import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { vehicleHeaderStyle, labelTextStyle, valueTextStyle } from "./styles";

const VehicleHeader = ({ vehicle, route }) => {
  const { t } = useTranslation();

  return (
    <Box sx={vehicleHeaderStyle}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          mb: { xs: 1, sm: 0 },
        }}
      >
        <Typography sx={labelTextStyle}>{t("Vehicle")}:</Typography>
        <Typography sx={valueTextStyle}>
          {vehicle?.name || "---"}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Typography sx={labelTextStyle}>{t("Route")}:</Typography>
        <Typography sx={valueTextStyle}>
          {route?.name || "---"}
        </Typography>
      </Box>
    </Box>
  );
};

export default VehicleHeader;
